import React, { useContext, useEffect } from "react";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../globalContext/auth/authProvider";
import { userRole } from "../constants";

function withPublicAccess(Component) {
  return (props) => {
    const [authState] = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
      if (
        _.isEmpty(authState?.token) &&
        window.location.pathname !== "/login/otp"
      ) {
        return;
      }
      if (
        !_.isEmpty(authState?.token) &&
        authState?.currentRole?.id !== userRole.DNSD
      ) {
        navigate("/");
      }
      if (
        (_.isEmpty(authState?.token) ||
          window.location.pathname === "/login/otp") &&
        _.isEmpty(authState?.authData)
      ) {
        navigate("/login");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return <Component {...props} />;
  };
}

export default withPublicAccess;
